import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 12.04 21.84"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.71 21.51c.43-.44.43-1.15 0-1.58L2.7 10.92l9.01-9.01c.43-.44.43-1.14 0-1.58-.44-.43-1.14-.43-1.58 0l-9.8 9.8c-.22.22-.33.5-.33.79s.11.57.33.79l9.8 9.8c.44.43 1.14.43 1.58 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }